<template>
  <v-app id="solicitudApertura">
    <v-content>
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-flex xs12 class="py-0">
            <h4 class="grey--text text--darken-1">
              <v-icon small color="primary">drag_indicator</v-icon> Solicitud de Apertura
            </h4>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-tabs
              v-model="active"
              centered
              max="2"
            >
              <v-tab
                key="datos"
                ripple
              >
                Datos del Centro
              </v-tab>
              <v-tab
                key="requisitos"
                ripple
              >
                Requisitos del Trámite
              </v-tab>
              <v-tab-item
                key="datos"
              >
                <v-card>
                  <v-card-text class="mx-0 px-0">
                    <v-form ref="form_apertura1">
                      <v-container grid-list-lg fluid>
                        <v-layout row wrap>
                          <v-flex xs12 class="my-0 py-0">
                            <v-card-title class="grey lighten-4 py-1 px-1">
                              <h3 class="grey--text text--darken-1">Datos Institucionales</h3>
                            </v-card-title>
                            <v-divider class="mb-0"></v-divider>
                          </v-flex>
                          <v-flex xs9 lg9 class="py-0">
                            <v-text-field
                              type="text"
                              label="Nombre del CCTP"
                              v-model.trim="apertura.institucional.nombre"
                              :rules="[v => !!v || 'El campo es requerido']"
                              class="txt-upper"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs3 lg3 class="py-0">
                            <v-text-field
                              type="text"
                              label="Sigla"
                              v-model.trim="apertura.institucional.sigla"
                              class="txt-upper"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 md6 lg3 class="py-0">
                            <v-select
                              :items="departamentos"
                              label="Departamento"
                              item-text="lugar"
                              item-value="id"
                              v-model="apertura.institucional.departamento_id"
                              @change="getProvincias(apertura.institucional.departamento_id)"
                              :rules="[v => !!v || 'Seleccione una opción']"
                              required
                            ></v-select>
                          </v-flex>
                          <v-flex xs6 md6 lg3 class="py-0">
                            <v-select
                              :items="provincias"
                              label="Provincia"
                              item-text="lugar"
                              item-value="id"
                              v-model="apertura.institucional.provincia_id"
                              @change="getMunicipios(apertura.institucional.provincia_id)"
                              :rules="[v => !!v || 'Seleccione una opción']"
                              required
                            ></v-select>
                          </v-flex>
                          <v-flex xs6 md6 lg3 class="py-0">
                            <v-select
                              :items="municipios"
                              label="Municipio"
                              item-text="lugar"
                              item-value="id"
                              v-model="apertura.institucional.municipio_id"
                              @change="getComunidades(apertura.institucional.municipio_id)"
                              :rules="[v => !!v || 'Seleccione una opción']"
                              required
                            ></v-select>
                          </v-flex>
                          <v-flex xs6 md6 lg3 class="py-0">
                            <v-select
                              :items="comunidades"
                              label="Comunidad"
                              item-text="lugar"
                              item-value="id"
                              v-model="apertura.institucional.comunidad_id"
                              :rules="[v => !!v || 'Seleccione una opción']"
                              required
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 sm7 md9 class="pt-0 pb-1">
                            <v-text-field
                              type="text"
                              label="Dirección"
                              v-model.trim="apertura.institucional.direccion"
                              :rules="[v => !!v || 'El campo es requerido']"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm5 md3 class="pt-0 pb-1">
                            <v-text-field
                              type="text"
                              label="Zona"
                              v-model.trim="apertura.institucional.zona"
                              :rules="[v => !!v || 'El campo es requerido']"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm4 class="pt-0 pb-1">
                            <v-text-field
                              type="number"
                              label="Teléfono"
                              v-model.trim="apertura.institucional.telefono"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm4 class="pt-0 pb-1">
                            <v-text-field
                              type="text"
                              label="Correo Electrónico"
                              v-model.trim="apertura.institucional.correo"
                              :rules="[v => !!v || 'El campo es requerido']"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm4 class="pt-0 pb-1">
                            <v-text-field
                              type="text"
                              label="Geolocalización"
                              v-model="apertura.institucional.geolocalizacion"
                              :rules="[v => !!v || 'El campo es requerido']"
                              append-icon="map"
                              readonly
                              @click="dialogMap = true"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout wrap>
                          <v-flex xs12 class="my-0 py-0">
                            <v-card-title class="grey lighten-4 py-1 px-1">
                              <h3 class="grey--text text--darken-1">Responsables del Centro de Capacitación (Propietario o Representante Legal)</h3>
                            </v-card-title>
                            <v-divider class="mb-0"></v-divider>
                          </v-flex>
                          <v-flex xs12 class="my-0 pt-2 pb-0">
                            <h3 class="grey--text text--darken-1">Propietario</h3>
                          </v-flex>
                          <v-flex xs12 sm6 class="py-0">
                            <v-text-field
                              type="text"
                              label="Nombres"
                              v-model.trim="apertura.propietario.nombre"
                              :rules="[v => !!v || 'El campo es requerido']"
                              @keypress="isText($event)"
                              class="txt-upper"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm3 class="py-0">
                            <v-text-field
                              type="text"
                              label="Apellido Paterno"
                              v-model.trim="apertura.propietario.paterno"
                              @keypress="isText($event)"
                              class="txt-upper"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm3 class="py-0">
                            <v-text-field
                              type="text"
                              label="Apellido Materno"
                              v-model.trim="apertura.propietario.materno"
                              @keypress="isText($event)"
                              class="txt-upper"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm6 md3 class="py-0">
                            <v-text-field
                              type="text"
                              label="Cédula de Identidad"
                              v-model.trim="apertura.propietario.cedula_identidad"
                              :rules="[v => !!v || 'El campo es requerido', v => (!!v && v.length > 3 && v.length < 8) || 'Mínimo 4 dígitos y máximo 7']"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm3 class="py-0">
                            <v-text-field
                              type="text"
                              label="Complemento"
                              v-model.trim="apertura.propietario.complemento"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm3 class="py-0">
                            <v-select
                              :items="departamentosE"
                              label="Expedido"
                              item-text="sigla"
                              item-value="id"
                              v-model="apertura.propietario.expedido"
                              :rules="[v => !!v || 'Seleccione una opción']"
                              required
                            ></v-select>
                          </v-flex>
                          <v-flex xs6 sm3 class="py-0">
                            <v-btn
                              flat
                              :loading="loadingSegipP"
                              outline
                              type="button"
                              color="primary"
                              @click="validarSegip(apertura.propietario, 1)"
                            >
                              Validar SEGIP
                            </v-btn>
                          </v-flex>
                          <v-flex xs6 sm3 class="py-0">
                            <v-menu
                              v-model="fechaNacProp"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="apertura.propietario.fecha_nacimiento"
                                  label="Fecha de Nacimiento"
                                  append-icon="event"
                                  :rules="[v => !!v || 'El campo es requerido']"
                                  readonly
                                  local
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker locale v-model="apertura.propietario.fecha_nacimiento" @input="fechaNacProp = false"></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs6 sm3 class="py-0">
                            <v-select
                              :items="generos"
                              label="Genero"
                              item-text="genero"
                              item-value="id"
                              v-model="apertura.propietario.genero_tipo_id"
                              :rules="[v => !!v || 'Seleccione una opción']"
                              required
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 md6 lg6 class="py-0">
                            <v-text-field
                              type="text"
                              label="Dirección"
                              v-model.trim="apertura.propietario.direccion"
                              :rules="[v => !!v || 'El campo es requerido']"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 md3 lg3 class="py-0">
                            <v-autocomplete
                              label="País"
                              :items="paises"
                              item-value="id"
                              item-text="pais"
                              v-model="apertura.propietario.pais_id"
                              :rules="[v => !!v || 'Seleccione una opción']"
                              @change="getDepartamentos(apertura.propietario.pais_id, 1)"
                              required
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs6 md3 lg3 class="py-0">
                            <v-select
                              :items="departamentos1"
                              label="Departamento"
                              item-text="lugar"
                              item-value="id"
                              v-model="apertura.propietario.departamento_id"
                              :rules="[v => !!v || 'Seleccione una opción']"
                              required
                            ></v-select>
                          </v-flex>
                          <!-- <v-flex xs4 class="py-0">
                            <v-select
                              :items="estado_civiles"
                              label="Estado Civil"
                              item-text="estado_civil"
                              item-value="id"
                              v-model="apertura.propietario.estadocivil_tipo_id"
                              :rules="[v => !!v || 'Seleccione una opción']"
                              required
                            ></v-select>
                          </v-flex> -->
                          <v-flex xs12 class="my-0 pt-2 pb-0">
                            <h3 class="grey--text text--darken-1">Representante Legal</h3>
                            <v-btn
                              flat
                              small
                              outline
                              type="button"
                              color="primary"
                              @click="copyPropietario(apertura.propietario)"
                            >
                              Replicar propietario
                            </v-btn>
                          </v-flex>
                          <v-flex xs12 sm6 class="py-0">
                            <v-text-field
                              type="text"
                              label="Nombres"
                              v-model.trim="apertura.representante_legal.nombre"
                              :rules="[v => !!v || 'El campo es requerido']"
                              @keypress="isText($event)"
                              class="txt-upper"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm3 class="py-0">
                            <v-text-field
                              type="text"
                              label="Apellido Paterno"
                              v-model.trim="apertura.representante_legal.paterno"
                              @keypress="isText($event)"
                              class="txt-upper"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm3 class="py-0">
                            <v-text-field
                              type="text"
                              label="Apellido Materno"
                              v-model.trim="apertura.representante_legal.materno"
                              @keypress="isText($event)"
                              class="txt-upper"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm6 md3 class="py-0">
                            <v-text-field
                              type="text"
                              label="Cédula de Identidad"
                              v-model.trim="apertura.representante_legal.cedula_identidad"
                              :rules="[v => !!v || 'El campo es requerido', v => (!!v && v.length > 3 && v.length < 8) || 'Mínimo 4 dígitos y máximo 7']"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm3 class="py-0">
                            <v-text-field
                              type="text"
                              label="Complemento"
                              v-model.trim="apertura.representante_legal.complemento"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 sm3 class="py-0">
                            <v-select
                              :items="departamentosE"
                              label="Expedido"
                              item-text="sigla"
                              item-value="id"
                              v-model="apertura.representante_legal.expedido"
                              :rules="[v => !!v || 'Seleccione una opción']"
                              required
                            ></v-select>
                          </v-flex>
                          <v-flex xs6 sm3 class="py-0">
                            <v-btn
                              flat
                              :loading="loadingSegipR"
                              outline
                              type="button"
                              color="primary"
                              @click="validarSegip(apertura.representante_legal, 2)"
                            >
                              Validar SEGIP
                            </v-btn>
                          </v-flex>
                          <v-flex xs6 sm3 class="py-0">
                            <v-menu
                              v-model="fechaNacRep"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="apertura.representante_legal.fecha_nacimiento"
                                  label="Fecha de Nacimiento"
                                  append-icon="event"
                                  :rules="[v => !!v || 'El campo es requerido']"
                                  readonly
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker locale v-model="apertura.representante_legal.fecha_nacimiento" @input="fechaNacRep = false"></v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs6 sm3 class="py-0">
                            <v-select
                              :items="generos"
                              label="Genero"
                              item-text="genero"
                              item-value="id"
                              v-model="apertura.representante_legal.genero_tipo_id"
                              :rules="[v => !!v || 'Seleccione una opción']"
                              required
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 md6 lg6 class="py-0">
                            <v-text-field
                              type="text"
                              label="Dirección"
                              v-model.trim="apertura.representante_legal.direccion"
                              :rules="[v => !!v || 'El campo es requerido']"
                              required
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs6 md3 lg3 class="py-0">
                            <v-autocomplete
                              label="País"
                              :items="paises"
                              item-value="id"
                              item-text="pais"
                              v-model="apertura.representante_legal.pais_id"
                              :rules="[v => !!v || 'Seleccione una opción']"
                              @change="getDepartamentos(apertura.representante_legal.pais_id, 2)"
                              required
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs6 md3 lg3 class="py-0">
                            <v-select
                              :items="departamentos2"
                              label="Departamento"
                              item-text="lugar"
                              item-value="id"
                              v-model="apertura.representante_legal.departamento_id"
                              :rules="[v => !!v || 'Seleccione una opción']"
                              required
                            ></v-select>
                          </v-flex>
                          <!-- <v-flex xs4 class="py-0">
                            <v-select
                              :items="estado_civiles"
                              label="Estado Civil"
                              item-text="estado_civil"
                              item-value="id"
                              v-model="apertura.representante_legal.estadocivil_tipo_id"
                              :rules="[v => !!v || 'Seleccione una opción']"
                              required
                            ></v-select>
                          </v-flex> -->
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex xs12 class="my-0 pb-0 pt-1">
                            <v-card-title class="grey lighten-4 py-0 px-1">
                              <h3 class="grey--text text--darken-1">Socios</h3>
                              <v-spacer></v-spacer>
                              <v-btn flat small outline color="primary" @click="showDialogSopefa(1)">Agregar Socio</v-btn>
                            </v-card-title>
                            <v-divider class="mb-0"></v-divider>
                          </v-flex>
                          <v-flex xs12 class="pt-0">
                            <v-data-table
                              :headers="headerSocio"
                              :items="apertura.socios"
                              class="elevation-1"
                              no-data-text="No existen registros"
                              hide-actions
                            >
                              <template v-slot:items="props">
                                <td>{{ props.index + 1 }}</td>
                                <td>{{ props.item.nombre }} {{ props.item.paterno }} {{ props.item.materno }}</td>
                                <td>{{ props.item.cedula_identidad }} {{ props.item.complemento }}</td>
                                <td>{{ props.item.expedido_nombre }}</td>
                                <td>{{ props.item.pais_nombre }}</td>
                                <td>{{ props.item.departamento_nombre }}</td>
                                <td>{{ props.item.direccion }}</td>
                                <td>
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{on}">
                                      <v-btn
                                        v-on="on"
                                        icon
                                        dark
                                        small
                                        color="red"
                                        @click="removeSopefa(props.index, 1)"
                                      >
                                        <v-icon small>delete</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Quitar registro</span>
                                  </v-tooltip>
                                </td>
                              </template>
                            </v-data-table>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex xs12 class="my-0 py-0">
                            <v-card-title class="grey lighten-4 py-0 px-1">
                              <h3 class="grey--text text--darken-1">Personal Administrativo</h3>
                              <v-spacer></v-spacer>
                              <v-btn flat small outline color="primary" @click="showDialogSopefa(2)">Agregar Personal</v-btn>
                            </v-card-title>
                            <v-divider class="mb-0"></v-divider>
                          </v-flex>
                          <v-flex xs12 class="pt-0">
                            <v-data-table
                              :headers="headerPersonalAdm"
                              :items="apertura.personal_administrativo"
                              class="elevation-1"
                              no-data-text="No existen registros"
                              hide-actions
                            >
                              <template v-slot:items="props">
                                <td>{{ props.index + 1 }}</td>
                                <td>{{ props.item.nombre }} {{ props.item.paterno }} {{ props.item.materno }}</td>
                                <td>{{ props.item.cedula_identidad }} {{ props.item.complemento }} {{ props.item.expedido_nombre }}</td>
                                <td>{{ props.item.cargo_nombre }}</td>
                                <td>{{ props.item.formacion_profesional_nombre }}</td>
                                <td>{{ props.item.tipo_contrato }}</td>
                                <td>
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{on}">
                                      <v-btn
                                        v-on="on"
                                        icon
                                        dark
                                        small
                                        color="red"
                                        @click="removeSopefa(props.index, 2)"
                                      >
                                        <v-icon small>delete</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Quitar registro</span>
                                  </v-tooltip>
                                </td>
                              </template>
                            </v-data-table>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex xs12 class="my-0 py-0">
                            <v-card-title class="grey lighten-4 py-0 px-1">
                              <h3 class="grey--text text--darken-1">Curso(s) de Capacitación</h3>
                              <v-spacer></v-spacer>
                              <v-btn flat small outline color="primary" @click="showDialogCurso">Agregar Curso</v-btn>
                            </v-card-title>
                            <v-divider></v-divider>
                          </v-flex>
                          <v-flex xs12 class="pt-0">
                            <v-data-table
                              :headers="headerCurso"
                              :items="apertura.cursos_capacitacion"
                              class="elevation-1"
                              no-data-text="No existen registros"
                              hide-actions
                            >
                              <template v-slot:items="props">
                                <td>{{ props.index + 1 }}</td>
                                <td>{{ props.item.curso_nombre }}</td>
                                <td>{{ props.item.carga_horaria }}</td>
                                <td>{{ props.item.tiempo }}</td>
                                <td>
                                  <v-btn-toggle>
                                    <v-btn
                                      v-if="props.item.turno_m"
                                      small
                                      class="transparent"
                                    >
                                      Mañana
                                    </v-btn>
                                    <v-btn
                                      v-if="props.item.turno_t"
                                      small
                                      class="transparent"
                                    >
                                      Tarde
                                    </v-btn>
                                    <v-btn
                                      v-if="props.item.turno_n"
                                      small
                                      class="transparent"
                                    >
                                      Noche
                                    </v-btn>
                                  </v-btn-toggle>
                                </td>
                                <td>
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{on}">
                                      <v-btn
                                        v-on="on"
                                        icon
                                        dark
                                        small
                                        color="red"
                                        @click="removeCurso(props.index)"
                                      >
                                        <v-icon small>delete</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Quitar registro</span>
                                  </v-tooltip>
                                </td>
                              </template>
                            </v-data-table>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex xs12 class="my-0 py-0">
                            <v-card-title class="grey lighten-4 py-0 px-1">
                              <h3 class="grey--text text--darken-1">Facilitadores (por curso de capacitación)</h3>
                              <v-spacer></v-spacer>
                              <v-btn flat small outline color="primary" @click="showDialogSopefa(3)">Agregar Facilitador/a</v-btn>
                            </v-card-title>
                            <v-divider class="mb-0"></v-divider>
                          </v-flex>
                          <v-flex xs12 class="pt-0">
                            <v-data-table
                              :headers="headerFacilitador"
                              :items="apertura.facilitadores"
                              class="elevation-1"
                              no-data-text="No existen registros"
                              hide-actions
                            >
                              <template v-slot:items="props">
                                <td>{{ props.index + 1 }}</td>
                                <td>{{ props.item.curso_nombre }}</td>
                                <td>{{ props.item.nombre }} {{ props.item.paterno }} {{ props.item.materno }}</td>
                                <td>{{ props.item.cargo }}</td>
                                <td>{{ props.item.formacion_profesional }}</td>
                                <td>{{ props.item.tipo_contrato }}</td>
                                <td>
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{on}">
                                      <v-btn
                                        v-on="on"
                                        icon
                                        dark
                                        small
                                        color="red"
                                        @click="removeSopefa(props.index, 3)"
                                      >
                                        <v-icon small>delete</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Quitar registro</span>
                                  </v-tooltip>
                                </td>
                              </template>
                            </v-data-table>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-form>
                    <div class="text-xs-center mt-3">
                      <v-btn dark color="primary" @click="nextPage">Siguiente</v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item
                key="requisitos"
              >
                <v-card>
                  <v-card-text>
                    <v-form ref="form_apertura2">
                      <v-container grid-list-lg fluid>
                        <v-layout wrap>
                          <v-flex xs12 class="my-0 pt-0 pb-2">
                            <v-card-title class="grey lighten-4 py-1 px-1">
                              <h3 class="grey--text text--darken-1">Requisitos</h3>
                            </v-card-title>
                            <v-divider class="mb-0"></v-divider>
                          </v-flex>
                          <v-flex xs12 md6 class="py-0">
                            <v-checkbox
                              v-model="apertura.requisito.nota_solicitud"
                              label="Nota de Solicitud"
                              :rules="[v => !!v || 'Marque la opción']"
                              class="my-0 py-0"
                            ></v-checkbox>
                          </v-flex>
                          <v-flex xs12 md6 class="py-0">
                            <v-checkbox
                              label="C.I. Propietario/Representante legal"
                              v-model="apertura.requisito.ci_propietario_representante"
                              class="my-0 py-0"
                            ></v-checkbox>
                          </v-flex>
                          <v-flex xs12 md6 class="py-0">
                            <v-checkbox
                              label="NIT"
                              v-model="apertura.requisito.nit"
                              class="my-0 py-0"
                            ></v-checkbox>
                          </v-flex>
                          <v-flex xs12 md6 class="py-0">
                            <v-checkbox
                              label="FUNDEMPRESA"
                              v-model="apertura.requisito.fundempresa"
                              class="my-0 py-0"
                            ></v-checkbox>
                          </v-flex>
                          <v-flex xs12 md6 class="py-0">
                            <v-checkbox
                              label="Poder Notarial (si corresponde)"
                              v-model="apertura.requisito.poder_notarial"
                              class="my-0 py-0"
                            ></v-checkbox>
                          </v-flex>
                          <v-flex xs12 md6 class="py-0">
                            <v-checkbox
                              label="Folio Real (propietario)/form. información rápida(inquilino)"
                              v-model="apertura.requisito.folio_real"
                              class="my-0 py-0"
                            ></v-checkbox>
                          </v-flex>
                          <v-flex xs12 md6 class="py-0">
                            <v-checkbox
                              label="Contrato de Alquiler (original/fotocopia legalizada)"
                              v-model="apertura.requisito.contrato_alquiler"
                              class="my-0 py-0"
                            ></v-checkbox>
                          </v-flex>
                          <v-flex xs12 md6 class="py-0">
                            <v-checkbox
                              label="Plano de Infraestructura"
                              v-model="apertura.requisito.plano_infraestructura"
                              class="my-0 py-0"
                            ></v-checkbox>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex xs12 class="my-0 py-0">
                            <v-card-title class="grey lighten-4 py-1 px-1">
                              <h3 class="grey--text text--darken-1">Proyecto Educativo Institucional</h3>
                            </v-card-title>
                            <v-divider class="mb-0"></v-divider>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <h4 class="grey--text text--darken-2 mb-2">Documentos Institucionales</h4>
                            <v-checkbox v-model="apertura.requisito.reglamento_interno" label="Reglamento Interno" class="my-0 py-0"></v-checkbox>
                            <v-checkbox v-model="apertura.requisito.infraestructura" label="Infraestructura" class="my-0 py-0"></v-checkbox>
                            <v-checkbox v-model="apertura.requisito.espacio_administrativo" label="Espacio Administrativo" class="my-0 py-0"></v-checkbox>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <h4 class="grey--text text--darken-2 mb-2">Equipamiento</h4>
                            <v-checkbox v-model="apertura.requisito.maquinaria_equipo" label="Maquinaria y Equipos" class="my-0 py-0"></v-checkbox>
                            <v-checkbox v-model="apertura.requisito.herramienta" label="Herramientas" class="my-0 py-0"></v-checkbox>
                            <v-checkbox v-model="apertura.requisito.instrumento" label="Instrumentos" class="my-0 py-0"></v-checkbox>
                            <v-checkbox v-model="apertura.requisito.tarjeta_propiedad" label="Tarjeta de Propiedad (caso de autoescuela)" class="my-0 py-0"></v-checkbox>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-form>
                    <div class="text-xs-center mt-3">
                      <v-btn color="primary" dark @click="confirmSolicitudApertura">Guardar</v-btn>
                    </div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <v-dialog v-model="dialogSopefa" scrollable :width="(size_width>1024?'60%':'100%')">
      <v-card>
        <v-card-title class="headline grey lighten-3">
          <span class="headline">Agregar {{ title_sopefa }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-lg fluid class="py-1">
            <v-form ref="form_sopefa">
              <v-layout rows wrap>
                <v-flex xs12 sm4 class="py-0">
                  <v-text-field
                    type="text"
                    label="Nombres"
                    v-model.trim="sopefa.nombre"
                    :rules="[v => !!v || 'El campo es requerido']"
                    @keypress="isText($event)"
                    class="txt-upper"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm4 class="py-0">
                  <v-text-field
                    type="text"
                    label="Apellido Paterno"
                    v-model.trim="sopefa.paterno"
                    @keypress="isText($event)"
                    class="txt-upper"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm4 class="py-0">
                  <v-text-field
                    type="text"
                    label="Apellido Materno"
                    v-model.trim="sopefa.materno"
                    @keypress="isText($event)"
                    class="txt-upper"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 class="py-0">
                  <v-text-field
                    type="text"
                    label="Cédula de Identidad"
                    v-model.trim="sopefa.cedula_identidad"
                    :rules="[v => !!v || 'El campo es requerido', v => (!!v && v.length > 3) || 'Mínimo 4 dígitos']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 class="py-0">
                  <v-text-field
                    type="text"
                    label="Complemento"
                    v-model.trim="sopefa.complemento"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 class="py-0">
                  <v-select
                    :items="departamentosE"
                    label="Expedido"
                    item-text="sigla"
                    item-value="id"
                    v-model="sopefa.expedido"
                    :rules="[v => !!v || 'Seleccione una opción']"
                  ></v-select>
                </v-flex>
                <v-flex xs6 class="py-0">
                  <v-menu
                    v-model="fechaNacPrs"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="sopefa.fecha_nacimiento"
                        label="Fecha de Nacimiento"
                        append-icon="event"
                        :rules="[v => !!v || 'El campo es requerido']"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker locale v-model="sopefa.fecha_nacimiento" @input="fechaNacPrs = false"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6 class="py-0">
                  <v-select
                    :items="generos"
                    label="Genero"
                    item-text="genero"
                    item-value="id"
                    v-model="sopefa.genero_tipo_id"
                    :rules="[v => !!v || 'Seleccione una opción']"
                    required
                  ></v-select>
                </v-flex>
                <!-- <v-flex xs6 sm4 class="py-0">
                  <v-select
                    :items="estado_civiles"
                    label="Estado Civil"
                    item-text="estado_civil"
                    item-value="id"
                    v-model="sopefa.estadocivil_tipo_id"
                    :rules="[v => !!v || 'Seleccione una opción']"
                    required
                  ></v-select>
                </v-flex> -->
                <v-flex xs12 sm4 class="py-0" v-if="tipo_sopefa == 1">
                  <v-text-field
                    type="text"
                    label="Dirección"
                    v-model.trim="sopefa.direccion"
                    :rules="[v => !!v || 'El campo es requerido']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm4 class="py-0" v-if="tipo_sopefa == 1">
                  <v-autocomplete
                    :items="paises"
                    label="País"
                    item-text="pais"
                    item-value="id"
                    v-model="sopefa.pais_id"
                    :rules="[v => !!v || 'Seleccione una opción']"
                    @change="getDepartamentos(sopefa.pais_id, 3)"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6 sm4 class="py-0" v-if="tipo_sopefa == 1">
                  <v-select
                    :items="departamentos3"
                    label="Departamento"
                    item-text="lugar"
                    item-value="id"
                    v-model="sopefa.departamento_id"
                    :rules="[v => !!v || 'Seleccione una opción']"
                  ></v-select>
                </v-flex>
                <v-flex xs6 sm4 class="py-0" v-if="tipo_sopefa == 2 || tipo_sopefa == 3">
                  <v-select
                    :items="formaciones"
                    label="Formación Profesional"
                    item-text="formacion"
                    item-value="id"
                    v-model="sopefa.formacion_profesional"
                    :rules="[v => !!v || 'Seleccione una opción']"
                  ></v-select>
                </v-flex>
                <v-flex xs6 sm4 class="py-0" v-if="tipo_sopefa == 2 || tipo_sopefa == 3">
                  <v-select
                    :items="cargos"
                    label="Cargo"
                    item-text="cargo"
                    item-value="id"
                    v-model="sopefa.cargo"
                    :rules="[v => !!v || 'Seleccione una opción']"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm4 class="py-0" v-if="tipo_sopefa == 2 || tipo_sopefa == 3">
                  <v-select
                    :items="tipo_contratos"
                    label="Tipo de Contrato"
                    item-text="tipo_contrato"
                    item-value="id"
                    v-model="sopefa.tipo_contrato"
                    :rules="[v => !!v || 'Seleccione una opción']"
                  ></v-select>
                </v-flex>
                <v-flex xs12 class="py-0" v-if="tipo_sopefa == 3">
                  <v-select
                    :items="apertura.cursos_capacitacion"
                    label="Curso"
                    item-text="curso_nombre"
                    item-value="curso_capacitacion"
                    v-model="sopefa.curso_capacitacion"
                    :rules="[v => !!v || 'Seleccione una opción']"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="loadingSegipS" color="success darken-1" flat @click="agregarSopefa">
            Agregar
          </v-btn>
          <v-btn color="blue darken-1" flat @click="dialogSopefa = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCurso" scrollable :width="(size_width>1024?'60%':'100%')">
      <v-card>
        <v-card-title class="headline grey lighten-3">
          <span class="headline">Agregar Curso</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-lg fluid class="py-1">
            <v-form ref="form_curso">
              <v-layout row wrap>
                <v-flex xs12 sm6 class="py-0">
                  <v-autocomplete
                    :items="cursos"
                    label="Curso"
                    item-text="nombre"
                    item-value="id"
                    v-model="curso.curso_capacitacion"
                    :rules="[v => !!v || 'Seleccione una opción']"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6 sm3 class="py-0">
                  <v-text-field
                    type="text"
                    label="Carga Horaria"
                    v-model.trim="curso.carga_horaria"
                    :rules="[v => !!v || 'El campo es requerido', v => (!!v && v > 19) || 'Valor mínimo 20', v => (!!v && v < 301) || 'Valor máximo 300']"
                    @keypress="isNumber($event)"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm3 class="py-0">
                  <v-text-field
                    type="text"
                    label="Tiempo (mes)"
                    v-model.trim="curso.tiempo"
                    :rules="[v => !!v || 'El campo es requerido', v => (!!v && v > 0) || 'Valor mínimo 1', v => (!!v && v < 5) || 'Valor máximo 4']"
                    @keypress="isNumber($event)"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 class="my-0 pb-0">
                  <h3 class="grey--text text--darken-1">Turno</h3>
                </v-flex>
                <v-flex xs12 sm4 md4 class="py-0">
                  <v-checkbox
                    class="my-0"
                    v-model="curso.turno_m"
                    label="Mañana"
                    hide-details
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 sm4 md4 class="py-0">
                  <v-checkbox
                    class="my-0"
                    v-model="curso.turno_t"
                    label="Tarde"
                    hide-details
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 sm4 md4 class="py-0">
                  <v-checkbox
                    class="my-0"
                    v-model="curso.turno_n"
                    label="Noche"
                    hide-details
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success darken-1" flat @click="agregarCurso">
            Agregar
          </v-btn>
          <v-btn color="blue darken-1" flat @click="dialogCurso = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogMap" persistent :width="(size_width>1024?'51%':'90%')">
      <v-card>
        <v-card-title class="headline grey lighten-3">
          <span class="headline">Geolocalización</span>
        </v-card-title>
        <v-card-text class="text-xs-center">
          <p class="grey--text text--darken-2">Marque la ubicación del Centro de Capacitación Técnica Privado.</p>
          <div id="geomap" style="width: 100% !important; height: 50vh"></div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialogMap = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mconfirm" persistent width="300px">
      <v-card>
        <v-card-title class="headline grey lighten-3">
          <span class="headline">Alerta</span>
        </v-card-title>
        <v-card-text class="text-xs-center">
          <p :class="color_txt + '--text text--darken-2 subheading'">
            {{ message }}
          </p>
          <v-btn
            v-if="hide_accept == false"
            outline
            color="primary"
            @click="formularioCctpAp"
            class="mt-3"
          >
            Imprimir Formulario
          </v-btn>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="hide_accept" :loading="loading" color="success darken-1" flat @click="createTramiteApertura">
            Aceptar
          </v-btn>
          <v-btn color="blue darken-1" flat @click="mconfirm = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snack.state"
      top
      right
      :timeout="2500"
      :color="snack.color"
      :multi-line="snack.mode === 'multi-line'"
    >
      {{ snack.text }}
    </v-snackbar>
  </v-app>
</template>

<script>
import Service from "../services/general";
import axios from "axios";
export default {
  name: 'solicitud-apertura',
  data: () => ({
    loading: false,
    loadingPrint: false,
    color_txt: '',
    hide_accept: true,
    loadingSegipP: false,
    loadingSegipR: false,
    loadingSegipS: false,
    active: null,
    headerSocio: Service.headerTable().socio,
    headerPersonalAdm: Service.headerTable().personal,
    headerFacilitador: Service.headerTable().facilitador,
    headerCurso: Service.headerTable().curso,
    fechaNacProp: false,
    fechaNacRep: false,
    fechaNacPrs: false,
    paises: [],
    departamentos: [],
    departamentos1: [],
    departamentos2: [],
    departamentos3: [],
    departamentosE: [],
    provincias: [],
    municipios: [],
    comunidades: [],
    tipo_contratos: [],
    generos: [],
    estado_civiles: [],
    cargos: [],
    formaciones: [],
    cursos: [],
    apertura: {
      tramite_id: '',
      devolucion: 0,
      institucional: {
        sede_central: true,
        nombre: '',
        sigla: '',
        departamento_id: '',
        departamento_nombre: '',
        provincia_id: '',
        provincia_nombre: '',
        municipio_id: '',
        comunidad_id: '',
        direccion: '',
        zona: '',
        calle: '',
        telefono: '',
        correo: '',
        geolocalizacion: ''
      },
      propietario: {
        nombre: '',
        paterno: '',
        materno: '',
        cedula_identidad: '',
        complemento: '',
        expedido: '',
        genero_tipo_id: '',
        estadocivil_tipo_id: '',
        fecha_nacimiento: '',
        pais_id: '',
        pais_nombre: '',
        departamento_id: '',
        departamento_nombre: '',
        direccion: '',
        segip_id: 0
      },
      representante_legal: {
        nombre: '',
        paterno: '',
        materno: '',
        cedula_identidad: '',
        complemento: '',
        expedido: '',
        genero_tipo_id: '',
        estadocivil_tipo_id: '',
        fecha_nacimiento: '',
        pais_id: '',
        pais_nombre: '',
        departamento_id: '',
        departamento_nombre: '',
        direccion: '',
        segip_id: 0
      },
      socios: [],
      personal_administrativo: [],
      facilitadores: [],
      cursos_capacitacion: [],
      requisito: {
        nota_solicitud: false,
        ci_propietario_representante: false,
        nit: false,
        fundempresa: false,
        poder_notarial: false,
        folio_real: false,
        contrato_alquiler: false,
        plano_infraestructura: false,
        reglamento_interno: false,
        infraestructura: false,
        espacio_administrativo: false,
        maquinaria_equipo: false,
        herramienta: false,
        instrumento: false,
        tarjeta_propiedad: false
      }
    },
    title_sopefa: '',
    tipo_sopefa: '',
    sopefa: {
      nombre: '',
      paterno: '',
      materno: '',
      cedula_identidad: '',
      complemento: '',
      expedido: '',
      expedido_nombre: '',
      genero_tipo_id: '',
      estadocivil_tipo_id: '',
      //Socio
      pais_id: '',
      pais_nombre: '',
      departamento_id: '',
      departamento_nombre: '',
      direccion: '',
      //Personal
      cargo: '',
      cargo_nombre: '',
      formacion_profesional: '',
      formacion_profesional_nombre: '',
      tipo_contrato: '',
      //Facilitador
      curso_capacitacion: '',
      tipo_contrato: '',
      segip_id: 0
    },
    curso: {
      curso_nombre: '',
      curso_capacitacion: '',
      carga_horaria: '',
      tiempo: '',
      turno_m: false,
      turno_t: false,
      turno_n: false
    },
    /* emailRules: [
      (v) => !!v || 'E-mail is required',
      (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
    ], */
    dialogSopefa: false,
    size_width: 0,
    dialogCurso: false,
    dialogMap: false,
    mconfirm: false,
    propietario_segip_id: 0,
    solicitud_id: '',
    map: null,
    snack: {
      state: false,
      color: "success",
      mode: "",
      timeout: 2500,
      text: ""
    },
    message: ""
  }),
  mounted() {
    let self = this;
    var lmarker, cmarker;
    this.map = new mapboxgl.Map({
      container: 'geomap',
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [-63.588654, -16.290154], 
      zoom: 4
    });
    this.map.addControl(new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      countries: 'bo',
      placeholder: 'Buscar lugar',
      zoom: 11
    }));
    this.map.addControl(new mapboxgl.NavigationControl());
    this.map.doubleClickZoom.disable();
    this.map.on('click', ev => {
      if (lmarker)
        lmarker.remove();
      cmarker = new mapboxgl.Marker()
      .setLngLat([ev.lngLat.lng, ev.lngLat.lat])
      .addTo(this.map);
      self.apertura.institucional.geolocalizacion = JSON.stringify([ev.lngLat.lat, ev.lngLat.lng]);
      lmarker = cmarker;
    });
    this.tipo_contratos = Service.tipoContrato();
    this.getPaises();
    this.getDepartamentos(1, 0);
    this.getExpedidos(1);
    this.getCargoFormacion();
    this.getGeneroEstadoCivil();
    this.getCursos();
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWidth);
      this.getWidth();
    });
  },
  methods: {
    getWidth() {
      this.size_width = document.documentElement.clientWidth;
    },
    getPaises() {
      axios.get(Service.getServe() + 'out/pais').then(response => {
        this.paises = response.data;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getExpedidos(pais_id) {
      Service.expedidos(pais_id).then(response => {
        this.departamentosE = response.data;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getDepartamentos(pais_id, tipo) {
      Service.lugarTipo(Service.nivel().departamento, pais_id).then(response => {
        if (tipo == 0) {
          this.departamentos = response.data;
        } else if(tipo == 1) {
          this.departamentos1 = response.data;
        } else if(tipo == 2) {
          this.departamentos2 = response.data;
        } else if(tipo == 3) {
          this.departamentos3 = response.data;
        }
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getProvincias(departamento_id) {
      Service.lugarTipo(Service.nivel().provincia, departamento_id).then(response => {
        this.provincias = response.data;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getMunicipios(provincia_id) {
      Service.lugarTipo(Service.nivel().municipio, provincia_id).then(response => {
        this.municipios = response.data;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getComunidades(municipio_id) {
      Service.lugarTipo(Service.nivel().comunidad, municipio_id).then(response => {
        this.comunidades = response.data;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getGeneroEstadoCivil() {
      Service.generoEstadoCivil().then(response => {
        this.generos = response.data.genero;
        this.estado_civiles = response.data.estado_civil;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getCargoFormacion() {
      Service.cargoFormacion().then(response => {
        this.cargos = response.data.cargo;
        this.formaciones = response.data.formacion;
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    getCursos() {
      Service.cursos().then(response => {
        this.cursos = response.data;console.log(this.cursos);
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    nextPage() {
      if (this.$refs.form_apertura1.validate()) {
        if (this.apertura.personal_administrativo.length > 0 && this.apertura.cursos_capacitacion.length > 0 && this.apertura.facilitadores.length > 0) {
          const active = parseInt(this.active)
          this.active = (active < 1 ? active + 1 : 0)
        } else {
          this.toast('warning', 'Debe agregar Personal Administrativo, Cursos y Facilitadores');
        }
      } else {
        this.toast('warning', 'Debe ingresar los datos requeridos');
        this.active = 0;
      }
    },
    confirmSolicitudApertura() {
      if (this.$refs.form_apertura1.validate()) {
        if (this.$refs.form_apertura2.validate()) {
          this.color_txt = 'grey';
          this.hide_accept = true;
          this.message = '¿Está seguro de enviar la Solicitud de Trámite de Apertura con la información ingresada?';
          this.mconfirm = true;
        } else {
          this.toast('warning', 'Debe completar los datos del segundo formulario');
        }
      } else {
        this.active = 0;
        this.toast('warning', 'Debe completar los datos del primer formulario');
      }
    },
    createTramiteApertura() {
      this.loading = true;
      this.apertura.institucional.sigla = (this.apertura.institucional.sigla == '' ? this.apertura.institucional.sigla : this.apertura.institucional.sigla.toUpperCase());
      this.apertura.institucional.nombre = this.apertura.institucional.nombre.toUpperCase();
      
      var indexDepto = this.departamentos.findIndex(x => x.id === this.apertura.institucional.departamento_id);
      this.apertura.institucional.departamento_nombre = (indexDepto!=-1)?this.departamentos[indexDepto].lugar:'';
      var indexProv = this.provincias.findIndex(x => x.id === this.apertura.institucional.provincia_id);
      this.apertura.institucional.provincia_nombre = (indexProv!=-1)?this.provincias[indexProv].lugar:'';

      var indexPais = this.paises.findIndex(x => x.id === this.apertura.propietario.pais_id);
      this.apertura.propietario.pais_nombre = (indexPais!=-1)?this.paises[indexPais].pais:'';
      indexDepto = this.departamentos.findIndex(x => x.id === this.apertura.propietario.departamento_id);
      this.apertura.propietario.departamento_nombre = (indexDepto!=-1)?this.departamentos[indexDepto].lugar:'';

      indexPais = this.paises.findIndex(x => x.id === this.apertura.representante_legal.pais_id);
      this.apertura.representante_legal.pais_nombre = (indexPais!=-1)?this.paises[indexPais].pais:'';
      indexDepto = this.departamentos.findIndex(x => x.id === this.apertura.representante_legal.departamento_id);
      this.apertura.representante_legal.departamento_nombre = (indexDepto!=-1)?this.departamentos[indexDepto].lugar:'';
      
      this.apertura.propietario.nombre = this.apertura.propietario.nombre.toUpperCase();
      this.apertura.propietario.paterno = (this.apertura.propietario.paterno == '' ? this.apertura.propietario.paterno : this.apertura.propietario.paterno.toUpperCase());
      this.apertura.propietario.materno = (this.apertura.propietario.materno == '' ? this.apertura.propietario.materno : this.apertura.propietario.materno.toUpperCase());

      this.apertura.representante_legal.nombre = this.apertura.representante_legal.nombre.toUpperCase();
      this.apertura.representante_legal.paterno = (this.apertura.representante_legal.paterno == '' ? this.apertura.representante_legal.paterno : this.apertura.representante_legal.paterno.toUpperCase());
      this.apertura.representante_legal.materno = (this.apertura.representante_legal.materno == '' ? this.apertura.representante_legal.materno : this.apertura.representante_legal.materno.toUpperCase());
      axios
        .post(Service.getBase() + 'nueva/apertura', this.apertura)
        .then(response => {
          this.loading = false;
          if (response.data.estado == 200) {
            this.solicitud_id = response.data.id;
            this.color_txt = 'success';
            this.$refs.form_apertura1.reset();
            this.$refs.form_apertura2.reset();
            this.hide_accept = false;
          } else {
            this.color_txt = 'error';
            this.hide_accept = true;
          }
          this.message = response.data.msg;
        })
        .catch(error => {
          this.loading = false;
          this.color_txt = 'error';
          this.hide_accept = true;
          this.message = "No se pudo registrar la Solicitud del Trámite de Apertura";
          console.error("Error al guardar", error);
        });
    },
    showDialogSopefa(tipo) {
      this.tipo_sopefa = tipo;
      if(tipo == 1) {
        this.title_sopefa = 'Socio';
      } else if(tipo == 2) {
        this.title_sopefa = 'Personal';
      }else {
        this.title_sopefa = 'Facilitadora/o';
      }
      this.departamentos3 = [];
      this.$refs.form_sopefa.reset();
      this.dialogSopefa = true;
    },
    agregarSopefa() {
      if(this.$refs.form_sopefa.validate()) {
        if (Service.validateSegip()) {
          this.loadingSegipS = true;
          Service.postValidarSegip(this.sopefa).then(response => {
            this.loadingSegipS = false;
            if (response.data.valido == 1) {
              this.sopefa.segip_id = response.data.valido;
              this.toast('success', response.data.msg);
              this.addSopefa();
            } else {
              this.toast('warning', response.data.msg);
            }
          }).catch(error => {
            this.loadingSegipS = false;
          });
        } else {
          this.sopefa.segip_id = 0;
          this.addSopefa();
        }
      }
    },
    addSopefa() {
      let dpto_id = this.departamentos.findIndex(x => x.id === this.sopefa.departamento_id);
      if (this.tipo_sopefa == 1) {
        let pais_id = this.paises.findIndex(x => x.id === this.sopefa.pais_id);
        this.apertura.socios.push({
          nombre: this.sopefa.nombre.toUpperCase(),
          paterno: this.sopefa.paterno.toUpperCase(),
          materno: this.sopefa.materno.toUpperCase(),
          cedula_identidad: this.sopefa.cedula_identidad,
          complemento: this.sopefa.complemento,
          expedido: this.sopefa.expedido,
          expedido_nombre: dpto_id==-1?'': this.departamentos[dpto_id].sigla,
          fecha_nacimiento: this.sopefa.fecha_nacimiento,
          genero_tipo_id: this.sopefa.genero_tipo_id,
          estadocivil_tipo_id: this.sopefa.estadocivil_tipo_id,
          pais_id: this.sopefa.pais_id,
          pais_nombre: pais_id==-1?'': this.paises[pais_id].pais,
          departamento_id: this.sopefa.departamento_id,
          departamento_nombre: dpto_id==-1?'': this.departamentos[dpto_id].lugar,
          direccion: this.sopefa.direccion,
          segip_id: this.sopefa.segip_id
        });
      } else if (this.tipo_sopefa == 2) {
        let cargo_id = this.cargos.findIndex(x => x.id === this.sopefa.cargo);
        let formacion_id = this.formaciones.findIndex(x => x.id === this.sopefa.formacion_profesional);
        this.apertura.personal_administrativo.push({
          nombre: this.sopefa.nombre.toUpperCase(),
          paterno: this.sopefa.paterno.toUpperCase(),
          materno: this.sopefa.materno.toUpperCase(),
          cedula_identidad: this.sopefa.cedula_identidad,
          complemento: this.sopefa.complemento,
          expedido: this.sopefa.expedido,
          expedido_nombre: dpto_id==-1?'': this.departamentos[dpto_id].sigla,
          fecha_nacimiento: this.sopefa.fecha_nacimiento,
          genero_tipo_id: this.sopefa.genero_tipo_id,
          estadocivil_tipo_id: this.sopefa.estadocivil_tipo_id,
          cargo: this.sopefa.cargo,
          cargo_nombre: cargo_id==-1?'': this.cargos[cargo_id].cargo,
          formacion_profesional: this.sopefa.formacion_profesional,
          formacion_profesional_nombre: formacion_id==-1?'': this.formaciones[formacion_id].formacion,
          tipo_contrato: this.sopefa.tipo_contrato,
          segip_id: this.sopefa.segip_id
        });
      } else {
        let cargo_id = this.cargos.findIndex(x => x.id === this.sopefa.cargo);
        let formacion_id = this.formaciones.findIndex(x => x.id === this.sopefa.formacion_profesional);
        let curso_id = this.cursos.findIndex(x => x.id === this.sopefa.curso_capacitacion);
        this.apertura.facilitadores.push({
          nombre: this.sopefa.nombre.toUpperCase(),
          paterno: this.sopefa.paterno.toUpperCase(),
          materno: this.sopefa.materno.toUpperCase(),
          cedula_identidad: this.sopefa.cedula_identidad,
          complemento: this.sopefa.complemento,
          expedido: this.sopefa.expedido,
          expedido_nombre: dpto_id==-1?'': this.departamentos[dpto_id].sigla,
          fecha_nacimiento: this.sopefa.fecha_nacimiento,
          genero_tipo_id: this.sopefa.genero_tipo_id,
          estadocivil_tipo_id: this.sopefa.estadocivil_tipo_id,
          curso_capacitacion: this.sopefa.curso_capacitacion,
          curso_nombre: curso_id==-1?'': this.cursos[curso_id].nombre,
          cargo: this.sopefa.cargo,
          cargo_nombre: cargo_id==-1?'': this.cargos[cargo_id].cargo,
          formacion_profesional: this.sopefa.formacion_profesional,
          formacion_profesional_nombre: formacion_id==-1?'': this.formaciones[formacion_id].formacion,
          tipo_contrato: this.sopefa.tipo_contrato,
          segip_id: this.sopefa.segip_id
        });
      }
      this.dialogSopefa = false;
    },
    removeSopefa(index, tipo_sopefa) {
      if (tipo_sopefa == 1) {
        this.apertura.socios.splice(index, 1);
      } else if (tipo_sopefa == 2) {
        this.apertura.personal_administrativo.splice(index, 1);
      } else {
        this.apertura.facilitadores.splice(index, 1);
      }
    },
    showDialogCurso() {
      this.$refs.form_curso.reset();
      this.dialogCurso = true;
    },
    agregarCurso() {
      if(this.$refs.form_curso.validate()) {
        if ((this.curso.turno_m == undefined || this.curso.turno_m == false) && (this.curso.turno_t == undefined || this.curso.turno_t == false) && (this.curso.turno_n == undefined || this.curso.turno_n == false)) {
          this.toast('warning', 'Marque por lo menos una o todos los turnos.');
        } else {
          let curso_id = this.cursos.findIndex(x => x.id === this.curso.curso_capacitacion);
          if (curso_id != -1) {
            this.curso.curso_nombre = this.cursos[curso_id].nombre;
            this.apertura.cursos_capacitacion.push(this.curso);
          }
          this.curso = {
            curso_nombre: '',
            curso_capacitacion: '',
            carga_horaria: '',
            tiempo: '',
            turno_m: false,
            turno_t: false,
            turno_n: false
          };
          this.dialogCurso = false;
        }
      }
    },
    removeCurso(index) {
      this.apertura.cursos_capacitacion.splice(index, 1);
    },
    validarSegip(persona, tipo) {
      let solicitante = tipo;
      if (persona.cedula_identidad != '' && persona.nombre != '' && (persona.paterno != '' || persona.materno != '') && persona.fecha_nacimiento != '') {
        if (tipo == 1) {
          this.loadingSegipP = true;
        } else {
          this.loadingSegipR = true;
        }
        if (Service.validateSegip()) {
          Service.postValidarSegip(persona).then(response => {
            this.loadingSegipP = false;
            this.loadingSegipR = false;
            if (response.data.valido == 1) {
              persona.segip_id = response.data.valido;
              this.propietario_segip_id = tipo == 1 ? persona.segip_id : 0;
              this.toast('success', response.data.msg);
            } else {
              this.toast('warning', response.data.msg);
              if (solicitante == 1){  //si no se validan todos los campos con segip el ususario debe rellenar todos los campos de nuevo
                this.apertura.propietario.cedula_identidad = '';
                this.apertura.propietario.nombre = '';
                this.apertura.propietario.paterno = '';
                this.apertura.propietario.materno = '';
                this.apertura.propietario.fecha_nacimiento = '';
                this.apertura.propietario.complemento = '';
                this.apertura.propietario.expedido = '';
                this.apertura.propietario.genero_tipo_id = '';
              }else{
                this.apertura.representante_legal.cedula_identidad = '';
                this.apertura.representante_legal.nombre = '';
                this.apertura.representante_legal.paterno = '';
                this.apertura.representante_legal.materno = '';
                this.apertura.representante_legal.fecha_nacimiento = '';
                this.apertura.representante_legal.complemento = '';
                this.apertura.representante_legal.expedido = '';
                this.apertura.representante_legal.genero_tipo_id = '';
              }
            }
          }).catch(() => {
            this.loadingSegipP = false;
            this.loadingSegipR = false;
          });
        }
      } else {
        this.toast('warning', 'Ingrese la información necesaria para validar con SEGIP');
      }
    },
    copyPropietario(propietario) {
      if (Service.validateSegip()) {
        if (this.propietario_segip_id == 1) {
          this.replicateData(propietario);
        } else {
          this.toast('warning', 'Debe realizar la validación con SEGIP');
        }
      } else {
        this.replicateData(propietario);
      }
    },
    async replicateData(propietario) {
      if (propietario.nombre == '' || propietario.cedula_identidad == '' || propietario.expedido == '' || propietario.pais_id == '' || propietario.departamento_id == '' || propietario.direccion == '' || propietario.fecha_nacimiento == '' || propietario.genero_tipo_id == '') {
        this.toast('warning', 'Complete datos del Propietario para replicar');
      } else {
        this.apertura.representante_legal = propietario;
        await this.getDepartamentos(this.apertura.propietario.pais_id, 2);
        this.apertura.representante_legal.departamento_id = propietario.departamento_id;
      }
    },
    formularioCctpAp() {//this.solicitud_id = 51;
      axios.get(Service.getServe() + 'cctp/obtiene/apertura/' + this.solicitud_id).then(response => {
        Service.formularioCctpApertura(response.data);
      }).catch(error => {
        console.error('Error al cargar datos', error);
      });
    },
    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWidth);
  }
};
</script>
<style scoped>
  canvas.mapboxgl-canvas {
    width: 100% !important;
  }
</style>
